import PropTypes from 'prop-types';
import React from 'react';

import { Carousel, CarouselProvider } from '$partials/base/carousel.jsx';
import { CarouselControls } from '$partials/ui';
import { StaticTitle } from '$partials/layout/side-titles.jsx';
import { ProjectLargeItem } from '$partials/listings/items';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselWorkLarge = ({
    items     = null,
    sideTitle = null
}) => {
    // render
    return (
        <CarouselProvider>
            <section className='module-carousel-work-large'>
                <div className='pr-gutter mxn-gutter'>  {/* outer grid gutter */}
                    {/* carousel controls */}
                    <div className='mb6 sm-mb6 md-mb7'>
                        <div className='col-12'>
                            <div className='ml9 sm-ml9 md-m0'>
                                <CarouselControls />
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-wrap'>
                        {/* side title */}
                        <div className='absolute md-relative md-col-2'>
                            {sideTitle && (
                                <div className='px-gutter'>
                                    <p className='type-style-5 side-title side-title--no-top'>
                                        <StaticTitle title={sideTitle} />
                                    </p>
                                </div>
                            )}
                        </div>

                        {/* content */}
                        <div className='col-12 md-col-10'>
                            <div className='ml9 sm-ml9 md-m0'>
                                <div className='module-carousel-work-large__carousel'>
                                    <Carousel
                                        items={items?.map((item, i) => {
                                            return (
                                                <ProjectLargeItem
                                                    {...item.page}
                                                    index={i}
                                                    key={i} />
                                            );
                                        })}
                                        slideClassName='module-carousel-work-large__card px-gutter'
                                        swiperConfig={{
                                            simulateTouch: true,
                                            slidesPerView: 'auto'
                                        }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </CarouselProvider>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

CarouselWorkLarge.propTypes = {
    items:     PropTypes.array.isRequired,
    sideTitle: PropTypes.string
};

export { CarouselWorkLarge };

export default CarouselWorkLarge;
